import React, { FC, ReactNode, useEffect, useState } from "react";
import { DEMO_HOTEL_LISTINGS, DEMO_STAY_LISTINGS } from "data/listings";
import { HotelDataType, HotelType, StayDataType } from "data/types";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import HeaderFilter from "./HeaderFilter";
import StayCard from "components/StayCard/StayCard";
import PropertyCardH from "components/PropertyCardH/PropertyCardH";
import Pagination from "shared/Pagination/Pagination";
import { DEMO_HOTELS } from "data/hotels";
import { apiHotels } from "data/api/hotels/api.hotels";
import useAuth from "components/Authprovider/Auth";

// OTHER DEMO WILL PASS PROPS
const DEMO_DATA: HotelType[] = DEMO_HOTELS.filter((_, i) => i < 8);
const DEMO_DATA2: StayDataType[] = DEMO_STAY_LISTINGS.filter((_, i) => i );
//
export interface SectionGridFeaturePlacesProps {
  stayListingsHotel?: HotelType[];
  stayListingsHome?: StayDataType[];
  gridClass?: string;
  heading?: ReactNode;
  subHeading?: ReactNode;
  headingIsCenter?: boolean;
  tabs?: string[];
}

const SectionGridFeaturePlaces: FC<SectionGridFeaturePlacesProps> = ({
  stayListingsHotel = [],
  stayListingsHome = DEMO_DATA2,
  gridClass = "",
  heading = "Featured places to stay",
  subHeading = "Popular places that Nilebooking recommends to you",
  headingIsCenter,
  tabs = ["Hotels", "Apartments"],
}) => {

  const {token} = useAuth()
  const {user} = useAuth()

  const [hotels,setHotels] = useState(stayListingsHotel)

  
  //Hotels Pagination
  const dataLimit = 8;
  const [pages] = React.useState(Math.round(stayListingsHotel.length / dataLimit));
  const [currentPage, setCurrentPage] = React.useState(1);

  function changePage(event: React.MouseEvent<HTMLButtonElement>) {
    const pageNumber = Number(event.currentTarget.textContent);
    setCurrentPage(pageNumber);
  }

  const getPaginatedData = () => {
    const startIndex = currentPage * 8 - dataLimit;
    const endIndex = startIndex + dataLimit;
    return stayListingsHotel.slice(startIndex, endIndex);
  };

  //Real Estate Pagination
  const homesLimit = 4;
  const [pagesHomes] = React.useState(Math.round(stayListingsHome.length / homesLimit));
  const [currentPageHome, setCurrentPageHome] = React.useState(1);

  function changePageHome(event: React.MouseEvent<HTMLButtonElement>) {
    const pageNumber = Number(event.currentTarget.textContent);
    setCurrentPageHome(pageNumber);
  }

  const getPaginatedDataHome = () => {
    const startIndex = currentPageHome * homesLimit - homesLimit;
    const endIndex = startIndex + homesLimit;
    return stayListingsHome.slice(startIndex, endIndex);
  };

  const [tabActive,setTabActive] = useState("Hotels")

  const renderCard = (stay: HotelType ) => {
    return <StayCard key={stay.id} data={stay} />;
  };

  const renderHotels = (stay: HotelType[]) => {
    return(
      <>
        <div
        className={`grid gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 ${gridClass}`}
      >
        {
           getPaginatedData().map((item) => (
            renderCard(item)
          ))
        }
      </div>
      <div className="flex mt-16 justify-center items-center">
        <Pagination
              pages={pages}
              currentPage={currentPage}
              changePage={changePage}
          />
      </div>
      </>
    );
  };

  const renderEstates = (stay: StayDataType[]) =>{
    
    return(
      <>
        <div className="grid grid-cols-1 gap-6 md:gap-8 xl:grid-cols-2 ">
        {getPaginatedDataHome().map((stay) => (
          <PropertyCardH key={stay.id} data={stay} />
        ))}
      </div>
      <div className="flex mt-16 justify-center items-center">
        <Pagination
              pages={pagesHomes}
              currentPage={currentPageHome}
              changePage={changePageHome}
          />
      </div>
      </>
    )
  }

  const renderFeatured = () => {
    switch (tabActive) {
      case "Hotels":
        return renderHotels(hotels);
      case "Apartments":
        return renderEstates(DEMO_DATA2);
      default:
        return null;
    }
  };
  return (
    <div className="nc-SectionGridFeaturePlaces relative" id="nc-SectionGridFeaturePlaces">
      <HeaderFilter
        tabActive={"Hotels"}
        subHeading={subHeading}
        tabs={tabs}
        heading={heading}
        onClickTab={(tab) => { setTabActive(tab)}}
      />
      {
        renderFeatured()
      }
    </div>
  );
};

export default SectionGridFeaturePlaces;
